import { createContext } from 'react';
export default createContext(false);



// WEBPACK FOOTER //
// ./src/context/isAdminContext.js